/* @flow */
export const validation = {
  headingMaxChar: 120,
  paragraphMaxChar: 1500,
  blockTitleMaxChar: 40,
  blockParagraphMaxChar: 1000
}
